import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';

import { input } from '$gbusiness/helpers';
import { FormSection } from '$gcomponents/reusables';
import { Button, Text } from '$gcomponents/primitives';

import { SHIPPING_METHOD_FORM } from './shippingMethodForm';
import { AppForm } from '$styles/general';
import MuiModal from '$gcomponents/reusables/modal/material';
import intl from '$intl';
import { factoryActions } from '$fbusiness/redux/factory';
import { AppModel } from '$business/redux/';
import { SimpleModel } from '$gbusiness/models/simple';
import { configs } from '$configs';

interface ShippingMethodModalProps {
  shippingMethod: SimpleModel;
  onClose: Function;
}

const ShippingMethodModal: React.FC<ShippingMethodModalProps> = ({ shippingMethod, onClose }) => {
  const dispatch = useDispatch();
  const isFinished = useSelector((state: AppModel) => state.factory.isFinished);
  const formRef = useRef<any>();

  useEffect(() => {
    if (!isFinished) return;

    dispatch(factoryActions.resetFinished());
    onClose();
  }, [isFinished, onClose, dispatch]);

  if (!shippingMethod) return null;
  const { id, ...initialValues } = shippingMethod;

  const onSubmit = (values) => {
    dispatch(
      factoryActions.saveObj(
        id || 0,
        values,
        configs.api.shippingMethod,
        factoryActions.fetchShippingMethods,
      ),
    );
  };

  const validateForm = (values) => input.validateError(SHIPPING_METHOD_FORM, values);

  return (
    <Formik
      innerRef={formRef}
      enableReinitialize={true}
      initialValues={initialValues}
      validate={validateForm}
      onSubmit={(values) => {
        onSubmit(values);
      }}>
      {(formik) => (
        <MuiModal
          open={!!shippingMethod}
          width="400px"
          onClose={() => onClose()}
          title={intl('SCREEN.FACTORY.SHIPPING_METHOD_TITLE')}
          footer={
            <Button fullWidth onClick={formik.handleSubmit} disabled={!(formik.isValid && formik.dirty)}>
              <Text k="BUTTON.SAVE" />
            </Button>
          }>
          <div className="content">
            <AppForm>
              <FormSection FORM={SHIPPING_METHOD_FORM} formik={formik} />
            </AppForm>
          </div>
        </MuiModal>
      )}
    </Formik>
  );
};

export default ShippingMethodModal;
